import type { ActionItem } from '@/api/types';
import type { FundAvg } from '../hooks/useSafeScores';

/** Promedio asumido cuando el fundamental elegido todavía no tiene puntaje. */
const FALLBACK_CHALLENGE_AVG = 1;

export interface DailyChallenge {
  /** Fundamental sobre el que se propone trabajar hoy. */
  fundamentalId: string;
  /** Acción sugerida del catálogo, o undefined si ninguna aplica. */
  action?: ActionItem;
}

/**
 * Elige el fundamental del reto diario y la acción asociada. Prioriza el primer
 * fundamental por debajo del umbral de crecimiento y, si no hay ninguno, el peor
 * puntuado. Entre las acciones activas prefiere la que cubre el rango del puntaje
 * actual; si no existe, cualquiera del fundamental.
 */
export function resolveDailyChallenge(
  fundAvgs: readonly FundAvg[],
  growthCandidates: readonly FundAvg[],
  sortedByScore: readonly FundAvg[],
  actions: readonly ActionItem[],
): DailyChallenge {
  const fundamentalId = growthCandidates[0]?.id
    ?? sortedByScore[sortedByScore.length - 1]?.id
    ?? '';

  const currentAvg = fundAvgs.find(item => item.id === fundamentalId)?.avg ?? FALLBACK_CHALLENGE_AVG;
  const activeActions = actions.filter(
    action => action.fundamentalId === fundamentalId && action.active,
  );
  const inRange = activeActions.find(
    action => currentAvg >= action.threshold && currentAvg <= action.thresholdMax,
  );

  return { fundamentalId, action: inRange ?? activeActions[0] };
}
